// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"ca2a3239","357":"6fa31e9a","425":"1e7580be","851":"9da50c74","941":"228a1a01"}[chunkId] + ".chunk.js";
};